import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Returns the corresponding file extension for a given MIME type.
 * @param {string} mimeType - The MIME type (e.g., "image/jpeg", "application/pdf").
 * @returns {string} - The file extension including the dot (e.g., ".jpg", ".pdf") or an empty string if unknown.
 */
export function getFileExtensionByMime(mimeType) {
  const mimeMap = {
    "application/pdf": ".pdf",
    "image/jpeg": ".jpg",
    "image/png": ".png",
    "image/gif": ".gif",
    "image/webp": ".webp",
    "application/msword": ".doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      ".docx",
    "application/vnd.ms-excel": ".xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      ".xlsx",
  };
  return mimeMap[mimeType] || ".pdf";
}